import Status from 'clarks/components/ivu-table/status'

let exports = {
   fixed: { forms: [
         { type: "text", form_type: "number", class: "col-12", validation: "required|numeric|min:1|max:5", model: "discount_val", label: "Discount Val", sub_label: "What amount do you want to issue the customer", placeholder: 'e.g KSH 200' },
      ] 
   },
   percentage: { forms: [
         { type: "text", form_type: "number", class: "col-12", validation: "required|numeric|min:1|max:2", model: "discount_val", label: "Discount Val", sub_label: "What percentage do you want to issue the customer", placeholder: 'e.g 10%'  },
         { type: "text", form_type: "number", class: "col-12", validation: "numeric", model: "max_discount_amount", label: "Max Discount Amount", sub_label: "What is the maximum discount amount the customer can be issued", placeholder: 'e.g Ksh 2000' },
      ]
   },
   product: { forms: [
         { type: "text", form_type: "number", class: "col-12", validation: "required|numeric|min:1|max:5", model: "discount_val", label: "Product Quantity", sub_label: "How many items are being issued", placeholder: 'e.g 2' },
         { type: "text", form_type: "text", class: "col-12", validation: "min:3|max:200", model: "product_name", label: "Product Name", sub_label: "Which product is being issued", placeholder: 'e.g 300ML Soda' },
      ] 
   },
}

let forms = {
   mainDetails: {
      icon: 'fa fa-tags',
      title: 'Main Details',
      subtitle: 'Configure the main details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:200", model: "name", label: "Name", sub_label: "What do you want to call this rule", placeholder: 'e.g Ultra Tech Promotion' },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "code", label: "Code", sub_label: "What code do you wish users to redeem this coupon with", placeholder: 'e.g ULTRA' },
         {
            type: 'form-select', class: 'col-12 col-md-6', model: 'discount_type', clearable: true, filterable: false, sub_label: "What type of discount do you want to issue", placeholder: 'e.g Percentage',
            options: [
               { val: "fixed", label: "Fixed", forms: exports.fixed.forms },
               { val: "percentage", label: "Percentage", forms: exports.percentage.forms },
               { val: "product", label: "Product", forms: exports.product.forms },
            ], validation: 'required', label: 'Discount Type'
         },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "from", label: "From", sub_label: "When does the promotion start", },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "to", label: "To", sub_label: "When does the promotion end", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '4', validation: 'required|min:10|max:500', label: 'Description', placeholder: 'Provide a description', sub_label: "What description do you want to provide to your customers", },
      ]
   },
   lockRules: {
      icon: 'fa fa-pencil-ruler',
      title: 'Lock Rules',
      subtitle: 'Lock in the discount rules',
      forms: [
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "countries", label: "Countries", sub_label: "Which countries will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "regions", label: "Regions", sub_label: "Which regions  will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "stations", label: "Stations", sub_label: "Which stations  will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "products", label: "Products", sub_label: "Which products will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "channels", label: "Channels", sub_label: "Which transaction channels  will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_types", label: "Transaction Types", sub_label: "Which transaction types  will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_subtypes", label: "Transaction Subtypes", sub_label: "Which transaction sub types  will trigger the rule", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "currencies", label: "Currencies", sub_label: "Which currencies  will trigger the rule", },
      ]
   },
   otherConfigs: {
      icon: 'fa fa-tools',
      title: 'Other Configs',
      subtitle: 'Extra rule configurations',
      forms: [
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "min_amount_spent", label: "Min Amount Spent", sub_label: "What is the minimum amount transacted to trigger the rule" },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_amount_spent", label: "Max Amount Spent", sub_label: "What is the minimum amount transacted to trigger the rule" },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_coupons_amount", label: "Maximum Total Discount Issued", sub_label: "What is your operating budget for this promotion" },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "", model: "remption_stations", label: "Redemption Stations", sub_label: "Which stations will the discount be redeemed", sub_label_bottom: 'Leave blank if you the discount can be redeemed anywhere' },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, validation: "", model: "multiple_coupons_config", label: "Multiple Coupons Config", sub_label: "How oftenly do you want this discounts to be issued",
            options: [
               { val: "daily", label: "Daily", },
               { val: "weekly", label: "Weekly", },
               { val: "monthly", label: "Monthly", },
               { val: "annually", label: "Annually", },
            ], sub_label_bottom: 'Leave blank if you don\'t want the discount to be recurring'
         },
      ]
   },
   addPromotionCoupon: {
      icon: 'fa fa-university',
      title: 'Add Promotion Coupon',
      subtitle: 'Provide Promotion Coupon Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "code", label: "Code", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "name", label: "Name", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true,
            options: [
               { val: "fixed", label: "Fixed", },
               { val: "percentage", label: "Percentage", },
               { val: "product", label: "Product", },
            ], validation: "required", model: "discount_type", label: "Discount Type",
         },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "required|numeric", model: "discount_val", label: "Discount Val", },
         { type: "text", form_type: "text", class: "col-12", validation: "min:3|max:200", model: "product_name", label: "Product Name", },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "from", label: "From", },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "to", label: "To", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '4', validation: 'required|min:10|max:500', label: 'Description', placeholder: 'Provide a description'},
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_discount_amount", label: "Max Discount Amount", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "countries", label: "Countries", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "regions", label: "Regions", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "stations", label: "Stations", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "products", label: "Products", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "channels", label: "Channels", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_types", label: "Transaction Types", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_subtypes", label: "Transaction Subtypes", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "currencies", label: "Currencies", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "min_amount_spent", label: "Min Amount Spent", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_amount_spent", label: "Max Amount Spent", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_coupons_amount", label: "Maximum Total Discount Issued", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, validation: "", model: "multiple_coupons_config", label: "Multiple Coupons Config",
            options: [
               { val: "daily", label: "Daily", },
               { val: "weekly", label: "Weekly", },
               { val: "monthly", label: "Monthly", },
               { val: "annually", label: "Annually", },
            ]
         },
      ]
   },
   editPromotionCoupon: {
      icon: 'fa fa-university',
      title: 'Edit Promotion Coupon',
      subtitle: 'Update Promotion Coupon Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "code", label: "Code", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "name", label: "Name", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true,
            options: [
               { val: "fixed", label: "Fixed", },
               { val: "percentage", label: "Percentage", },
               { val: "product", label: "Product", },
            ], validation: "required", model: "discount_type", label: "Discount Type",
         },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "required|numeric", model: "discount_val", label: "Discount Val", },
         { type: "text", form_type: "text", class: "col-12", validation: "min:3|max:200", model: "product_name", label: "Product Name", },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "from", label: "From", },
         { type: "datepicker", form_type: "date", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-12 col-md-6", validation: "required", model: "to", label: "To", },
         { type: 'textarea', class: 'col-12', model: 'description', rows: '4', validation: 'required|min:10|max:500', label: 'Description', placeholder: 'Provide a description'},
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_discount_amount", label: "Max Discount Amount", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "countries", label: "Countries", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "regions", label: "Regions", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "stations", label: "Stations", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "products", label: "Products", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "channels", label: "Channels", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_types", label: "Transaction Types", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "transaction_subtypes", label: "Transaction Subtypes", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, multiple: true, max_tag_count: 1, options: [], validation: "required", model: "currencies", label: "Currencies", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "min_amount_spent", label: "Min Amount Spent", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_amount_spent", label: "Max Amount Spent", },
         { type: "text", form_type: "number", class: "col-12 col-md-6", validation: "numeric", model: "max_coupons_amount", label: "Maximum Total Discount Issued", },
         { type: "select", class: "col-12 col-md-6", filterable: false, clearable: true, validation: "", model: "multiple_coupons_config", label: "Multiple Coupons Config",
            options: [
               { val: "daily", label: "Daily", },
               { val: "weekly", label: "Weekly", },
               { val: "monthly", label: "Monthly", },
               { val: "annually", label: "Annually", },
            ]
         },
      ]
   },
}

let tables = {
   promotion_coupon: {
      props: {
         icon: 'fa fa-gift',
         title: 'Promotion Coupon',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['code','name', 'discount_val', 'discount_type', 'product_name', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Code", key: "code", },
            { title: "Name", key: "name", },
            { title: "Discount Value", key: "discount_val", align: 'center' },
            { title: "Discount Type", key: "discount_type", align: 'center' },
            { title: "From", slot: "from", },
            { title: "To", slot: "to", },
            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Coupons Redeemed', event: 'view:redemptions', icon: 'fa-gift', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'promotion_coupon:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'promotion_coupon:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

forms = {...forms, mainDetailsEdit: forms.mainDetails, lockRulesEdit: forms.lockRules, otherConfigsEdit: forms.otherConfigs}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}